

if ($(window).width() < 1199) {

}
else {
    if($('.site-header').hasClass('bio-detail')) {
        $(".site-header").addClass("bg-white");
    }

    $(window).on("scroll", function() {
        if($(window).scrollTop() > 50) {
            $(".site-header").addClass("bg-white");
        } else {
            //remove the background property so it comes transparent again (defined in your css)
            if($('.site-header').hasClass('bio-detail')) {
                $(".site-header").addClass("bg-white");
            }
            else{
                $(".site-header").removeClass("bg-white");
            }
        }
    });

}
